
<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-sm-12">
          <div class="element-box mb-0">
            <h5 class="form-header">Inventario por Categoría</h5>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        current.errors.proveedor &&
                        current.errors.proveedor.length > 0,
                    }"
                  ></label>
                  <SubCategoriaSelectComponent
                    :current="current"
                  ></SubCategoriaSelectComponent>
                  <small
                    v-if="current.errors && current.errors.proveedor"
                    class="form-text text-danger"
                    >{{ current.errors.proveedor[0] }}</small
                  >
                </div>
              </div>
              <div class="col-md-12" v-if="current.subcategoria">
                <TiendaSelectComponent :current="current" />
              </div>
            </div>
            <div
              v-if="current.subcategoria && current.tienda"
              class="form-buttons-w"
            >
              <div>
                <button
                  class="btn btn-md btn-success btn-block"
                  @click="refresh"
                >
                  Refrescar
                </button>
              </div>
              <br />
              <div>
                <button
                  class="btn btn-md btn-dark btn-block"
                  @click="cleanFilters"
                >
                  Limpiar
                </button>
              </div>
              <router-link
                v-if="current.producto"
                class="btn btn-outline-info"
                :to="{
                  name: 'cat-productos-editar',
                  params: { sku: current.producto.sku },
                }"
              >
                <i class="fa fa-arrow-left"></i>
                Ir al Producto
              </router-link>
            </div>
            <div class="row">
              <div class="col-sm-12"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="element-wrapper">
            <div class="element-box">
              <br />
              <button
                type="button"
                v-if="datos"
                @click="imprimir(current)"
                class="btn btn-secondary btn-sm btn-block"
              >
                <span>Descargar en Excel</span>
              </button>
              <br />
              <br />
              <div class="table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Tienda</th>
                      <th>Sku</th>
                      <th>Descripcion</th>
                      <th class="text-right">minimo</th>
                      <th class="text-right">maximo</th>
                      <th class="text-right">Existencia</th>
                      <th class="text-center">Kardex</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in datos" :key="item.id">
                      <td>{{ item.tienda_nombre }}</td>
                      <td>
                        <router-link
                          :to="{
                            name: 'inventario-reportes-kardex',
                            params: {
                              sku: item.producto_id,
                              tienda: item.tienda_id,
                            },
                          }"
                          class="font-weight-bold"
                          style="color: ForestGreen"
                        >
                          <i class="fas fa-external-link-alt"></i>&nbsp;
                          <span>{{ item.producto_id }}</span>
                        </router-link>
                      </td>
                      <td>{{ item.producto_nombre }}</td>
                      <td class="text-right">{{ item.minimo }}</td>
                      <td class="text-right">{{ item.maximo }}</td>
                      <td
                        style="color: Blue"
                        class="text-right font-weight-bold"
                      >
                        {{ item.existencia }}
                      </td>
                      <td class="text-center">
                        <router-link
                          style="color: ForestGreen"
                          class="font-weight-bold"
                          :to="{
                            name: 'inventario-reportes-kardex',
                            params: {
                              sku: item.producto_id,
                              tienda: item.tienda_id,
                            },
                          }"
                        >
                          Ir
                          <i
                            style="color: ForestGreen"
                            class="fas fa-share-square"
                          ></i>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    TiendaSelectComponent,
    CategoriaSelectComponent,
    SubCategoriaSelectComponent,
  },
  data() {
    return {
      incluir_en_blanco: true,
      params: {},
      current: {
        subcategoria: "",
        buscar_por: "",
        producto: null,
        fecha_final: null,
        fecha_inicial: null,
        tienda: null,
        categoria: "",
        errors: {
          productos: null,
          fecha_inicial: null,
          fecha_final: null,
        },
      },
      datos: "",
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.tienda) {
      self.current.tienda = this.$route.params.tienda;
    }
  },
  methods: {
    cleanFilters() {
      this.current.categoria = "";
      this.current.tienda = null;
      this.datos = "";
    },
    imprimir(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=xls&report_name=inventario/inv_x_categoria/inventario_x_categoria.jrxml&categoria_id=${current.subcategoria.codigo}&tienda=${current.tienda}`
      );
    },
    onChangeProducto(producto) {
      let self = this;
      self.refreshProducto(self.current.producto.sku);
      // self.refreshUnidadMedida(producto);
    },
    refresh() {
      if (this.current.tienda) {
        this.params.tienda = this.current.tienda;
      }
      if (this.current.categoria) {
        this.params.categoria = this.current.categoria.codigo;
      }
      if (this.current.subcategoria) {
        this.params.subcategoria = this.current.subcategoria.codigo;
      }
      DynamicService.getActionList(
        "cat",
        "categoria",
        "existencia_de_productos",
        this.params
      )
        .then((res) => {
          this.datos = res.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>
